import { action, observable, computed } from "mobx";
import { persist } from "mobx-persist";

import {} from "../../services/api";

class UserModel {}

export default UserModel;
